'use client';

import styled from 'styled-components';

import { Flex } from '@zoomit/primitives';
import { Button, theme } from '@zoomit/zoomit-ds';

import type { SearchInstanceCategory } from '../../types/search';

type Props = {
  hasAllSearchResultChip?: boolean;
  selectedCategory: string;
  counts: Record<string, number>;
  handleChangeCategory: (category: string) => void;
  categories: SearchInstanceCategory[];
};

export const SearchCategory = (props: Props) => {
  const { hasAllSearchResultChip, counts, selectedCategory, handleChangeCategory, categories } = props;
  const allCategories = hasAllSearchResultChip
    ? [{ title: 'تمام نتایج', value: 'all' }, ...categories]
    : categories;

  return (
    <Root flexWrap="nowrap" gap={0.8} spacing={{ mt: 'x6' }}>
      {allCategories
        .filter((category) => counts[category.value] > 0)
        .map((category) => (
          <Button
            variant={selectedCategory === category.value ? 'contained' : 'outline'}
            key={category.value}
            size="fit"
            className="fa"
            colorScheme="default"
            onClick={() => handleChangeCategory(category.value)}
            rightIcon={<CountWrapper>{counts[category.value]}</CountWrapper>}
          >
            {category.title}
          </Button>
        ))}
    </Root>
  );
};

const Root = styled(Flex)`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  > * {
    white-space: nowrap;
    padding: 2px 8px 2px 1.6rem;
  }

  > :last-child {
    margin-left: 1.6rem;
  }
`;

const CountWrapper = styled.div`
  min-width: 2.4rem;
  height: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(${theme.radius.full});
  background-color: var(${theme.grey3});
  font-size: 12px;
  font-weight: 900;
  color: inherit;
  margin-right: -4px;
`;
